function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTunisia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 341.337",
    style: {
      enableBackground: "new 0 85.33 512 341.337"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621         c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38         C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.002,167.724c48.718,0,88.205,39.594,88.205,88.276c0,48.823-39.488,88.276-88.205,88.276         c-48.822,0-88.346-39.453-88.346-88.276C168.655,207.318,208.179,167.724,257.002,167.724"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M273.042,305.466c-27.327,0-49.493-22.165-49.493-49.461c0-27.23,22.165-49.395,49.493-49.395             c9.295,0,17.981,2.604,25.405,7.102c1.112,0.674,2.282-0.782,1.355-1.695c-11.138-10.974-26.389-17.771-43.236-17.771             c-34.2,0-61.891,27.692-61.891,61.761c0,34.135,27.691,61.825,61.891,61.825c16.838,0,32.083-6.792,43.219-17.763             c0.927-0.913-0.243-2.369-1.355-1.696C291.01,302.867,282.33,305.466,273.042,305.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M268.52,221.387l13.644,18.526l21.945-6.912c2.841-0.895,5.186,2.342,3.452,4.762l-13.402,18.701             l13.355,18.735c1.729,2.425-0.625,5.656-3.464,4.754l-21.927-6.968l-13.692,18.49c-1.772,2.393-5.572,1.154-5.591-1.825             l-0.149-23.007l-21.816-7.307c-2.825-0.946-2.819-4.943,0.008-5.881l21.835-7.252l0.207-23.007             C262.951,220.218,266.753,218.988,268.52,221.387z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTunisia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tunisia.9e486090948a7a97f2b7925ff3880303.svg";